/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M18 7.99999H10.5C8.01473 7.99999 6 10.0147 6 12.5V12.5C6 14.9853 8.01473 17 10.5 17H13M18 7.99999L16 6M18 7.99999L16 9.99999"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M18 7.99999H10.5C8.01473 7.99999 6 10.0147 6 12.5V12.5C6 14.9853 8.01473 17 10.5 17H13M18 7.99999L16 6M18 7.99999L16 9.99999M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM16.5303 5.46967C16.2374 5.17678 15.7626 5.17678 15.4697 5.46967C15.1768 5.76257 15.1768 6.23744 15.4697 6.53033L16.1893 7.24999H10.5C7.60052 7.24999 5.25 9.6005 5.25 12.5C5.25 15.3995 7.60052 17.75 10.5 17.75H13C13.4142 17.75 13.75 17.4142 13.75 17C13.75 16.5858 13.4142 16.25 13 16.25H10.5C8.42894 16.25 6.75 14.5711 6.75 12.5C6.75 10.4289 8.42894 8.74999 10.5 8.74999H16.1893L15.4697 9.46966C15.1768 9.76255 15.1768 10.2374 15.4697 10.5303C15.7626 10.8232 16.2374 10.8232 16.5303 10.5303L18.5303 8.53032C18.671 8.38966 18.75 8.1989 18.75 7.99999C18.75 7.80107 18.671 7.61031 18.5303 7.46966L16.5303 5.46967Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M2 14.5L2 15V15C2 16.8613 2 17.7919 2.24472 18.5451C2.73931 20.0673 3.93273 21.2607 5.45491 21.7553C6.20808 22 7.13872 22 9 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2L9 2C7.13872 2 6.20808 2 5.45491 2.24472C3.93273 2.73931 2.73931 3.93273 2.24472 5.45492C2 6.20808 2 7.13872 2 9V9L2 9.5M18 7.99999H10.5C8.01473 7.99999 6 10.0147 6 12.5V12.5C6 14.9853 8.01473 17 10.5 17H13M18 7.99999L16 6M18 7.99999L16 9.99999"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M18 7.99999H10.5C8.01473 7.99999 6 10.0147 6 12.5V12.5C6 14.9853 8.01473 17 10.5 17H13M18 7.99999L16 6M18 7.99999L16 9.99999M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.4697 5.46967C15.7626 5.17678 16.2374 5.17678 16.5303 5.46967L18.5303 7.46965C18.671 7.61031 18.75 7.80107 18.75 7.99999C18.75 8.1989 18.671 8.38966 18.5303 8.53032L16.5303 10.5303C16.2374 10.8232 15.7626 10.8232 15.4697 10.5303C15.1768 10.2374 15.1768 9.76255 15.4697 9.46966L16.1893 8.74999H10.5C8.42894 8.74999 6.75 10.4289 6.75 12.5C6.75 14.5711 8.42894 16.25 10.5 16.25H13C13.4142 16.25 13.75 16.5858 13.75 17C13.75 17.4142 13.4142 17.75 13 17.75H10.5C7.60052 17.75 5.25 15.3995 5.25 12.5C5.25 9.6005 7.60051 7.24999 10.5 7.24999H16.1893L15.4697 6.53033C15.1768 6.23744 15.1768 5.76257 15.4697 5.46967Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
